"use client";

import { Button } from "@/components/ui/button";
import { WidgetAPI } from "@/context/widget-context";
import { Language, useTranslations } from "@/lib";
import EmptyItem from "./empty-item";
import { ProductItem } from "./product-item";

export function Products({
  widget,
  lang,
}: {
  widget: WidgetAPI;
  lang: Language;
}) {
  const emptyItemsCount =
    widget.products.filter((product) => product.size !== "").length < 4
      ? 4 - widget.products.filter((product) => product.size !== "").length
      : 0;
  const emptyItems = Array(emptyItemsCount).fill(null);
  const handleRemoveProduct = (id: string) => {
    widget.removeProduct(id);
  };

  function handleEmptyItemClick() {
    const currentPath = window.location.pathname;
    const targetPath = "/collections/try-before-you-buy";
    widget.close();

    // Redirect only if not already on try-before-buy page
    if (!currentPath.includes(targetPath)) {
      // Preserve language prefix if it exists
      const langPrefix = currentPath.startsWith("/en")
        ? "/en"
        : currentPath.startsWith("/ar")
          ? "/ar"
          : "";

      window.location.href = `${window.location.origin}${langPrefix}${targetPath}`;
    }
  }

  return (
    <>
      <div className="tw:grid tw:gap-5 tw:px-4">
        {widget.products
          .filter((product) => product.size)
          .map((product, index) => (
            <ProductItem
              key={index}
              product={product}
              onRemove={() => handleRemoveProduct(product.id)}
              lang={lang}
            />
          ))}

        {emptyItems.map((_, index) => (
          <EmptyItem
            key={`empty-${index}`}
            onClick={handleEmptyItemClick}
            lang={lang}
          />
        ))}
      </div>
    </>
  );
}
export function ProductsButton({
  disabled,
  lang,
  widget,
}: {
  disabled?: boolean;
  lang: Language;
  widget: WidgetAPI;
}) {
  const { t } = useTranslations(lang);
  return (
    <>
      {widget.products.every(
        (product) => (product.cushionRecommendations?.length || 0) === 0,
      ) ? (
        <Button
          className="tw:!text-sm tw:md:!text-base tw:!h-13.5"
          disabled={disabled}
          onClick={() => widget.setStep(5)}
        >
          {t("schedule_free_trial_button_text")}
        </Button>
      ) : (
        <Button
          className="tw:!text-sm tw:md:!text-base tw:!h-13.5"
          disabled={disabled}
          onClick={() => widget.setStep(2)}
        >
          {t("schedule_free_trial_button_text")}
        </Button>
      )}
    </>
  );
}
